import * as React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Card, Button } from 'bloomer';
import { ButtonContainer, ConfirmPopUpTitle } from '../../../styles/styled-components/Form/FormComponent';
import styled from 'styled-components';
import { SubTitle, SubHeading } from '../../../styles/styled-components/User/User';
import i18next from 'i18next';

type ConfirmationPopupProps = {
  alertTitle: string;
  alertContent: string;
  subheading?: string;
  buttonName: string;
  isSuccess: boolean;
  onCloseButtonClick: () => void;
  onSuccessCallback: () => void;
};
export default class ConfirmationPopup extends React.PureComponent<ConfirmationPopupProps> {
  state = {
    errorMessage: '',
    loader: false,
  };
  submitButtonClick = async () => {
    try {
      this.setState({ loader: true });
      await this.props.onSuccessCallback();
    } catch (err) {
      this.setState({ errorMessage: err.message });
      this.setState({ loader: false });
    }
  }

  render() {
    const { loader } = this.state;
    return (
      <Card>
        <ActivationContainer>
          <ConfirmPopUpTitle>{this.props.alertTitle}</ConfirmPopUpTitle>
          <SubHeading>{this.props.subheading}</SubHeading>
          <SubTitle>{this.props.alertContent}</SubTitle>
          <ButtonContainer>
            {this.props.isSuccess ? undefined : <div><button className="button" onClick={() => this.closePopUp()} disabled={loader}>{i18next.t('transfer.cancelButton')}</button></div>}
            {/* <div><button className="button" type="submit" onClick={() => this.submitButtonClick()}>{this.props.buttonName}</button></div> */}
            <Button isLoading={loader} type="submit" onClick={() => this.submitButtonClick()}>{this.props.buttonName}</Button>
          </ButtonContainer>
        </ActivationContainer>
      </Card>
    );
  }
  closePopUp = () => {
    this.props.onCloseButtonClick && this.props.onCloseButtonClick();
  };

}

export const ActivationContainer = styled.div`
  width:80%;
  margin-left:60px;
`;